import './index.css';
import { createBrowserRouter, redirect, RouterProvider } from 'react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Login from './pages/login/Index.jsx';
import DashboardHome from './pages/dashboard/Index.jsx';
import Tunnel from './pages/dashboard/tunnel/Index.jsx';
import Layout from './pages/dashboard/Layout.jsx';
import DashboardProfile from './pages/dashboard/profile/Index.jsx';
import DashboardDocuments from './pages/dashboard/documents/Index.jsx';
import DashboardJobs from './pages/dashboard/jobs/Index.jsx';
import PasswordReset from './pages/password-reset/Index.jsx';
import PasswordRecovery from './pages/password-recovery/Index.jsx';
import Error from './pages/error/Error.jsx';
import Informations from './pages/dashboard/tunnel/informations/Index.jsx';
import Eligibilite from './pages/dashboard/tunnel/eligibilite';
import Documents from './pages/dashboard/tunnel/documents';
import Signature from './pages/dashboard/tunnel/signature';
import Finalisation from './pages/dashboard/tunnel/Finalisation';
import AxiosInstance from './utils/AxiosInstance';
import Succes from './pages/dashboard/profile/carte/succes';
import Echec from './pages/dashboard/profile/carte/echec';
import UserEmailContext from './context/UserEmailContext.jsx';
import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import { getAgeFromDateString, handlePromise, handleResponse } from './utils';
import axiosInstance from './utils/AxiosInstance';
import { getCurrentUser } from './utils/Sessions';

const App = () => {
  const queryClient = new QueryClient();
  const [userEmail, setUserEmail] = useState(null);
  const routes = createBrowserRouter([
    {
      path: '/login',
      Component: Login,
    },
    {
      path: '*',
      Component: Error,
    },
    {
      path: 'recuperation-mot-de-passe',
      Component: PasswordRecovery,
    },
    {
      path: 'definition-mot-de-passe',
      Component: PasswordReset,
    },
    {
      path: '/',
      errorElement: <Error />,
      Component: Layout,
      children: [
        { index: true, Component: DashboardHome },
        {
          path: '/inscription',
          Component: Tunnel,

          loader: async ({ params }) => {
            const me = getCurrentUser();
            try {
              const user = await queryClient.ensureQueryData({
                queryKey: ['user', me.user_id],
                queryFn: () => handlePromise(axiosInstance.get('/internal_api/user/me')),
              });
              const steps = await queryClient.ensureQueryData({
                queryKey: ['training', params.trainingId, 'steps'],
                queryFn: () =>
                  handlePromise(
                    axiosInstance.get(`/internal_api/tunnel/${params.trainingId}/get-training-current-status`)
                  ),
              });
              const isMineur = getAgeFromDateString(user.birth_day) < 18;
              if ((steps.length === 3 && isMineur) || steps.length === 4) return redirect('/');

              return params;
            } catch (e) {
              return { error: true, message: e.message };
            }
          },
          children: [
            { path: '/inscription/informations/:trainingId', Component: Informations },
            { path: '/inscription/eligibilite/:trainingId', Component: Eligibilite },
            { path: '/inscription/documents/:trainingId', Component: Documents },
            {
              path: '/inscription/signature/:trainingId',
              Component: Signature,
            },
            { path: '/inscription/finalisation/:trainingId', Component: Finalisation },
          ],
        },
        {
          path: 'mes-infos',
          children: [
            { index: true, Component: DashboardProfile },
            { path: 'carte/succes', Component: Succes },
            { path: 'carte/echec', Component: Echec },
          ],
        },
        { path: 'documents', Component: DashboardDocuments },
        { path: 'youschool-job', Component: DashboardJobs },
      ],
    },
  ]);

  return (
    <QueryClientProvider client={queryClient}>
      <UserEmailContext.Provider value={[userEmail, setUserEmail]}>
        <ToastContainer />
        <RouterProvider router={routes} />
      </UserEmailContext.Provider>
    </QueryClientProvider>
  );
};

export default App;
